<template lang="pug">
form-item-wrapper(v-bind="bind", :rules="rules", :class="formItemClass")
  el-select.width-full(v-if="isEdit", :value="listModel", :multiple="multiple", filterable, clearable, @input="setModel")
    el-option(v-for="item in optionList", :key="item.value", :label="item.label", :value="item.value")
  div(v-else)
    el-input.readonly-mode(v-model="fieldModelName", disabled)
</template>

<script>
import { mapVFAssignField, staticMixins } from "@/CommonDP/VForm/utils";
import flowService from "@/CommonDP/service/flow-service";
import { SPEC_TYPE } from "./index";
const separator = ",";
export default {
  mixins: [staticMixins],
  props: {},
  data() {
    return {
      optionList: []
    };
  },
  computed: {
    ...mapVFAssignField("specNameKey"),
    vmDefaultValue() {
      return "";
    },
    multiple() {
      return this.options.multiple2;
    },
    type() {
      return this.options.specType;
    },
    listModel() {
      const { fieldModel, multiple } = this;
      if (multiple) {
        return fieldModel ? fieldModel.split(separator) : [];
      }
      return fieldModel;
    },
    fieldModelName() {
      return this.getLabel();
    }
  },
  watch: {
    prjId() {
      this.initList();
    }
  },
  created() {
    this.initList();
  },
  methods: {
    async initList() {
      this.preventDesign();
      const map = {
        [SPEC_TYPE.USER.VALUE]: flowService.querySpecList,
        [SPEC_TYPE.PRJ_ALL.VALUE]: flowService.queryPrjAllSpec
      };
      const fun = map[this.type];
      let resList = [];
      let nameField;
      const { data } = await fun(this.prjId);
      if (this.type === SPEC_TYPE.PRJ_ALL.VALUE) {
        resList = data;
        nameField = "cnName";
      } else if (this.type === SPEC_TYPE.USER.VALUE) {
        resList = data?.flowSpecPoList || [];
        nameField = "name";
      }
      this.optionList = resList.map((it) => ({
        value: it.id,
        label: it[nameField]
      }));
      // this.watchField()
    },
    setModel(val) {
      const { multiple } = this;
      this.fieldModel = multiple ? (val || []).join(separator) : val;
      this.emitValidate();
    },
    withUpdate() {
      this.specNameKey = this.getLabel();
    },
    getLabel() {
      const labels = this.optionList
        .filter((it) => {
          if (this.multiple) {
            return this.listModel.includes(it.value);
          } else {
            return it.value === this.listModel;
          }
        })
        .map((i) => i.label);
      return labels.join(",");
    }
  }
};
</script>

<style scoped lang="scss">
.width-full {
  display: block;
}
.readonly-mode {
  width: 100%;
  display: inline-block;
  white-space: pre-wrap;
  line-height: 1.5;
  color: #c0c4cc;
}
</style>
